<div class="main">
    <div class="container">
        <div class="tab-property tab-scrollX" role="tabpanel" id="create-gold">
            <div class="tab-pane in active">
                <div class="row">
                    <div class="col-12">
                        <div class="createProduct">
                            <br />
                            <!-- Tab content -->
                            <div class="tab-content" [formGroup]="editForm">
                                <div class="tab-pane show active" id="tab1">
                                    <div class="d-flex flex-column" [ngClass]="isApproved && 'is-viewed'">
                                        <div class="createProduct__inner">
                                            <div class="row">
                                                <div class="form-group col-12"  *ngIf="!isApproved">
                                                    <div class="row">
                                                        <div class="col-12 mb-4">
                                                            <button class="btn btn--green" (click)="uploadImage.click();">Upload Image </button>
                                                            <input id="file-upload" #uploadImage style="display: none;" name="file" type="file" ng2FileSelect [uploader]="uploader" />
                                                        </div>
                                                        <div class="col-12">
                                                            <img [src]="editForm.value.imageUrl" width="200" height="200">
                                                        </div>
                                                    </div>
                                                </div>
                                                <!-- Name -->
                                                <div class="form-group col-12 col-md-6 col-sm-6">
                                                    <label
                                                        class="control-label input-title no-padding">{{'Tên Vàng & Bạc' | translate }}
                                                        <span class="required">*</span>
                                                    </label>
                                                    <input type="text" class="form-control" placeholder=""  readonly
                                                        formControlName="name" minlength="1" maxlength="255">
                                                    <span class="error-text" *ngIf="isValidated && !editForm.value.name">
                                                        {{'product.create.required_field' | translate }}
                                                    </span>
                                                </div>
                                                  <!-- Name -->
                                                  <div class="form-group col-12 col-md-6 col-sm-6">
                                                    <label
                                                        class="control-label input-title no-padding">{{'Tên Vàng & Bạc' | translate }} Tiếng Anh
                                                        <span class="required">*</span>
                                                    </label>
                                                    <input type="text" class="form-control" placeholder=""  
                                                        formControlName="nameEn" minlength="1" maxlength="255">
                                                    <span class="error-text" *ngIf="isValidated && !editForm.value.nameEn">
                                                        {{'product.create.required_field' | translate }}
                                                    </span>
                                                </div>
                                                <!-- Short name -->
                                                <div class="form-group col-12 col-md-6 col-sm-6">
                                                    <label
                                                        class="control-label input-title no-padding">{{'Tên viết tắt' | translate }}
                                                        <span class="required">*</span>
                                                    </label>
                                                    <input type="text" class="form-control" formControlName="shortName"
                                                        minlength="1" maxlength="255">
                                                    <span class="error-text" *ngIf="isValidated && !isApproved  && !editForm.value.shortName">
                                                        {{'product.create.required_field' | translate }}
                                                    </span>
                                                </div>
                                                <!-- Code -->
                                                <div class="form-group col-12 col-md-6 col-sm-6">
                                                    <label
                                                        class="control-label input-title no-padding">{{'Mã' | translate }}
                                                        <span class="required">*</span>
                                                    </label>
                                                    <input type="text" class="form-control" formControlName="code" minlength="1"
                                                        maxlength="255" readonly>
                                                    <span class="error-text" *ngIf="isValidated && !editForm.value.code">
                                                        {{'product.create.required_field' | translate }}
                                                    </span>
                                                </div>
                                                <!-- Loại -->
                                                <div class="form-group col-6 col-md-6 col-sm-6">
                                                    <label
                                                        class="control-label input-title no-padding">{{'Loại' | translate }}
                                                        <span class="required">*</span>
                                                    </label>
                                                    <select class="form-control" formControlName="goldTypeCode" disabled>
                                                        <option *ngFor="let type of types" [value]="type.goldId">{{type.goldName}} - Giá mua: {{type.rateBuy}} - Giá bán: {{type.rateSell}}</option>
                                                    </select>
                                                    <span class="error-text" *ngIf="isValidated && !editForm.value.goldTypeCode">
                                                        {{'product.create.required_field' | translate }}
                                                    </span>
                                                </div>
                                                <!-- Phí giữ vàng  -->
                                                <div class="form-group col-6 col-md-6 col-sm-6">
                                                    <label
                                                        class="control-label input-title no-padding">{{'Phí giữ Vàng & Bạc' | translate }}
                                                    </label>
                                                    <input type="text" class="form-control" [readonly]="isApproved"  formControlName="keepingFee">
                                                </div>
                                                <!-- Đơn vị -->
                                                <div class="form-group col-6 col-md-6 col-sm-6 vsdFeeId">
                                                    <label class="control-label input-title no-padding"> Đơn vị
                                                    </label>
                                                    <input type="text" class="form-control" readonly formControlName="goldUnit">
                                                </div>
                                                <!-- Mô tả -->
                                                <div class="form-group col-12">
                                                    <label
                                                        class="control-label input-title no-padding">{{'product.create.description'
                                                        | translate }}
                                                    </label>
                                                    <textarea class="col-md-12" rows="3"
                                                        formControlName="description" minlength="1"
                                                        maxlength="1000"
                                                        placeholder="Mô tả"></textarea>
                                                    <span id="charNum">{{editForm.value.description?.length ||
                                                        0}}/{{1000}}</span>
                                                </div>
                                                <div class="form-group col-12">
                                                    <label
                                                        class="control-label input-title no-padding">{{'product.create.description'
                                                        | translate }} Tiếng Anh
                                                    </label>
                                                    <textarea class="col-md-12" rows="3"
                                                        formControlName="descriptionEn" minlength="1"
                                                        maxlength="1000"
                                                        placeholder="Mô tả tiếng anh"></textarea>
                                                    <span id="charNum">{{editForm.value?.descriptionEn?.length ||
                                                        0}}/{{1000}}</span>
                                                </div>
                                            </div>
                                        </div>
                                      
                                        <hr>
                                    </div>

                                    <div class="row">
                                        <div class="form-group col-12 col-md-12"
                                            style="display: flex; justify-content: flex-end;padding-right: 50px;">
                                            <button class="btn btn-ok btn--green" (click)="approve()"
                                                style="margin-right: 5px" *ngIf="isApproved" [disabled]="isCalling">
                                                <i nz-icon nzType="sync" nzTheme="outline"></i><span
                                                    style="margin-left: 5px">Duyệt</span></button>
                                            <button class="btn btn-ok btn--green" (click)="save()"
                                                style="margin-right: 5px" *ngIf="!isApproved"><i nz-icon nzType="sync"
                                                    nzTheme="outline"></i><span style="margin-left: 5px">Sửa
                                                    đổi</span></button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>